import React, { FC, PropsWithChildren } from 'react';
import {
  Heading,
  HStack,
  IconButton,
  Spacer,
  Stack,
  Text,
  useColorModeValue,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { AddItemIcon } from 'components/icons';

interface OwnerPanelProps {
  title: React.ReactNode;
}

export const OwnerPanel: FC<PropsWithChildren<OwnerPanelProps>> = ({
  title,
  children,
}) => {
  const ownerPanelColor = useColorModeValue('gray.50', 'gray.700');

  return (
    <Stack>
      <Heading size="sm">{title}</Heading>
      <Stack bgColor={ownerPanelColor} borderRadius="md" p={2}>
        {children}
      </Stack>
    </Stack>
  );
};

interface OwnerPanelTitleProps {
  onAddOwners?: () => void;
}

export const OwnerPanelTitle: FC<PropsWithChildren<OwnerPanelTitleProps>> = ({
  children,
  onAddOwners,
}) => {
  return (
    <HStack>
      <Text>{children}</Text>
      <Spacer />
      {onAddOwners && (
        <IconButton
          colorScheme="blue"
          variant="ghost"
          onClick={onAddOwners}
          size="sm"
          icon={<AddItemIcon />}
          aria-label={t`Add owner`}
        />
      )}
    </HStack>
  );
};
